import React, { useState } from 'react';
import * as ui from '@digital/ui';
import { Modal, Tooltip } from 'antd';
import { hasPermission } from '@app/helpers/permissions';

import { Visibility, UploadFile } from '@app/components';

interface PropsModal {
  hasJustificativa: boolean;
  hasFile: boolean;
  hasData: boolean;
  label?: string;
  onSubmit: (values: any) => Promise<boolean>;
}

const UploadModalSubstituirAnexo = ({
  hasJustificativa = false,
  hasFile = false,
  hasData = false,
  label,
  onSubmit,
}: PropsModal) => {
  const [exibirModal, setExibirModal] = useState(false);

  return (
    <>
      <Tooltip title={hasFile ? "Adicionar" : "Substituir"}>
        <ui.Button
          icon="ui-upload"
          onClick={() => {
            setExibirModal(true);
          }}
        />
      </Tooltip>
      <Visibility
        visible={exibirModal}
      >
        <Modal
          title={hasFile ? "ADICIONAR ARQUIVO" : "SUBSTITUIR ARQUIVO"}
          width="860px"
          visible={exibirModal}
          onCancel={() => {
            setExibirModal(false);
          }}
          footer={null}>
          {exibirModal && (
            <ui.MasterDetailForm
              initialValues={{}}
              key="formSubstituirAnexo"
              onSubmit={(values) => {
                onSubmit(values)
                  .then(value => {
                    if (value) {
                      setExibirModal(false);
                    }
                  });
              }}
              actions={[
                <ui.Button
                  type="link"
                  onClick={() => {
                    setExibirModal(false);
                  }}>
                  Fechar
                </ui.Button>,
                <ui.FormSubmitButton
                  noIcon
                  type="primary"
                  disabled={!hasPermission(['PRE_SUPRIMENTOS_DEMANDA_SUBSTITUIR_ANEXO'])}>
                  <ui.FormatText id="ui.commons.save" uppercase />
                </ui.FormSubmitButton>,
              ]}>
              <ui.Widget>

                {hasJustificativa && (
                  <ui.FormInput name="justificativa" label="Justificativa" span={12} required />
                )}

                {hasData && (
                  <ui.FormDatePicker format="DD/MM/YYYY" label="Data" name="data" span={3} />
                )}

                <UploadFile
                  nameFormData={'arquivo'}
                  label={label}
                  hasFile={hasFile}
                  type="primary"
                  idDoComponente="sgc-upload-UploadModalSubstituirAnexo"
                />
              </ui.Widget>
            </ui.MasterDetailForm>
          )}
        </Modal>
      </Visibility>
    </>
  );
};

export default UploadModalSubstituirAnexo;
